import { render, staticRenderFns } from "./add_notice.vue?vue&type=template&id=7d5808ea&scoped=true&"
import script from "./add_notice.vue?vue&type=script&lang=js&"
export * from "./add_notice.vue?vue&type=script&lang=js&"
import style0 from "./add_notice.vue?vue&type=style&index=0&id=7d5808ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5808ea",
  null
  
)

export default component.exports